import List from './List'

export default List

export type { DividerPosition, ListProps, DividerProps } from './List'
